import { TextBox } from "devextreme-react";
import { NativeEventInfo } from "devextreme/events";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { TextBoxInstance } from "devextreme/ui/text_box";
import React, {
  Component,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { string } from "yup";

interface ItextBarcode {
  onBarcodeCommand: (command: string) => void;
  onBarcodeText: (
    e: NativeEventInfo<TextBoxInstance, Event> & ValueChangedInfo
  ) => void;
  name: string;
}

const Esaedro_TextBarcode = (props: ItextBarcode) => {
  const [barcodeValue, setBarcodeValue] = useState<string>();
  const textBox = useRef<TextBox | null>(null);

  const focusTextBox = useCallback(() => {
    textBox.current?.instance.focus();
  }, [textBox]);

  const handleValueChanged = (
    e: NativeEventInfo<TextBoxInstance, Event> & ValueChangedInfo
  ) => {
    setBarcodeValue(e.value);
    if (e.value.startsWith("!ESAEDRO!")) {
      const command = e.value.substring("!ESAEDRO!".length);

      props.onBarcodeCommand(command);
    } else {
      props.onBarcodeText(e);
    }

    setBarcodeValue("");
  };

  useEffect(() => {
    focusTextBox();
  }, [focusTextBox]);

  return (
    <TextBox
      ref={textBox}
      name={props.name}
      value={barcodeValue}
      onValueChanged={handleValueChanged}
      id={props.name}
      elementAttr={{
        field: props.name,
      }}
      inputAttr={{
        autofocus: true,
      }}
    />
  );
};

export default Esaedro_TextBarcode;
